import moment from "moment";

const formatDate = (dateString) => {
  if (!dateString) return "";
  try {
    return moment(dateString).format("DD.MM.YYYY, HH:mm:ss");
  } catch (e) {
    return "";
  }
};

export { formatDate };
